/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
const infiniteHits = instantsearch.widgets.infiniteHits;
const index = instantsearch.widgets.index;
const sessionStorageCache =
  instantsearch.createInfiniteHitsSessionStorageCache();
const { connectSortBy } = instantsearch.connectors;

(async function (algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var index_suffix = await algolia.config.index_suffix;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function (routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: true,
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
        algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
      },
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
          searchFunctionHelper.setQueryParameter('facetingAfterDistinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    search_article: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'articles' + index_suffix,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'articles' + index_suffix),
      },
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
          searchFunctionHelper.setQueryParameter('facetingAfterDistinct', true);
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    search_product_empty: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,
      // routing: {
      //   stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
      // },
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter('query', '');

        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
          searchFunctionHelper.setQueryParameter('facetingAfterDistinct', true);
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');

  algolia.instantsearch = instant;


  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }


  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function () {
    readjust();
  });

  instant.search.addWidgets([
    {
      init: function () {
        document.addEventListener('DOMContentLoaded', function (event) {
          $(document).ready(function (event) {
            $(document).on("click", ".ais-sort-container-mobile button", function (event) {
              $('.ais-sort-container-mobile').toggleClass('ais-sort-open');
            });

            $(document).on("click", ".ais-filter-container-mobile button", function (event) {
              $('.ais-facets').toggleClass('ais-facet-open');
              $('.ais-facets-mobile-footer-button').text('Close Filter');
              $('.ais-facets-mobile-footer-button').removeClass('ais-facets-mobile-footer-button-active');
              $('.ais-dropdown-checkbox').prop('checked', true);
            });


            $(document).on("click", ".ais-facets-mobile-footer-button", function (event) {
              $('.ais-facets').removeClass('ais-facet-open');
              $('.ais-facets-mobile-footer-button').text('Close Filter');
              $('.ais-facets-mobile-footer-button').removeClass('ais-facets-mobile-footer-button-active');
              $('.ais-dropdown-checkbox').prop('checked', true);
            });


            $(document).on("click", ".ais-Header-Tab-item", function (event) {
              const tab = $(this).attr('data-for');
              $('[data-tab]').addClass('tab-hidden');
              $(`[data-tab="${tab}"]`).removeClass('tab-hidden');
              $('.ais-Header-Tab-item').removeClass('active');
              $(this).addClass('active')
            });

            instant.search.on('render', () => {
              if ($('.ais-facets').hasClass('ais-facet-open')) {
                $('.ais-facets-mobile-footer-button').text('Apply');
                $('.ais-facets-mobile-footer-button').addClass('ais-facets-mobile-footer-button-active');
              }
            });
          });
        });
      }
    },
  ]);

  // Mobile facets display
  // instant.search.addWidgets([
  //   {
  //     init: function() {
  //       var $button = document.querySelector('.ais-facets-button');
  //       $button.addEventListener('click', function() {
  //         var $facets = document.querySelector('.ais-facets');

  //         if ($facets.classList.contains('ais-facets__shown')) {
  //           $button.textContent = 'Show filters';
  //           $facets.classList.remove('ais-facets__shown');
  //         } else {
  //           $button.textContent = 'Hide filters';
  //           $facets.classList.add('ais-facets__shown');
  //         }
  //       });
  //     },
  //   },
  // ]);

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  instant.search_article.addWidgets([
    searchBox({
      container: '.ais-search-box-container-2',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  //Logo & clear
  instant.search.addWidgets([
    {
      init: function (opts) {
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function () {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function (opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);

  //Logo & clear
  instant.search.addWidgets([
    {
      init: function (opts) { },
      render: function (opts) {
        if (opts.results && opts.results.nbHits)
          document.querySelector('.ais-Header-Tab-item[data-for="product"] .ais-item-count').innerText = `(${opts.results.nbHits})`;
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, { html }) {
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    }),
  ]);

  if (window.innerWidth > 1024) {
    // Sort orders
    if (activeSortOrders.length > 1) {
      instant.search.addWidgets([
        sortBy({
          container: '.ais-sort-orders-container',
          items: [
            ...instant.sortOrders
            // { label: 'Price low to high', value: 'patagonia_products_price_asc' },
          ],
        }),
      ]);
    }
  } else {
    // Sort orders
    if (activeSortOrders.length > 1) {
      const renderSortBy = (renderOptions, isFirstRender) => {
        const {
          options,
          currentRefinement,
          refine,
          widgetParams,
          // `canRefine` is only available from v4.45.0
          // Use `hasNoResults` in earlier minor versions.
          canRefine,
        } = renderOptions;

        if (isFirstRender) {
          const div = document.createElement('div');
          div.classList.add('ais-sort-items');

          // select.addEventListener('change', event => {
          //   refine(event.target.value);
          // });
          widgetParams.container.appendChild(div);
        }

        const clickHandler = (event) => {
          refine(event.target.dataset.value);
          $('.ais-sort-container-mobile').toggleClass('ais-sort-open');
        };

        const select = widgetParams.container.querySelector('.ais-sort-items');

        select.disabled = !canRefine;

        select.innerHTML = `
          ${options
            .map(
              option => `
                <span
                  data-value="${option.value}"
                  ${option.value === currentRefinement ? 'selected' : ''}
                >
                  ${option.label}
                </span>
              `
            )
            .join('')}
        `;

        select.querySelectorAll('span').forEach((span) => {
          span.addEventListener('click', clickHandler);
        });
      };

      // Create the custom widget
      const customSortBy = connectSortBy(renderSortBy);

      instant.search.addWidgets([
        customSortBy({
          container: document.querySelector('.ais-sort-items-container-mobile'),
          items: [
            ...instant.sortOrders
            // { label: 'Price low to high', value: 'patagonia_products_price_asc' },
            // { label: 'Price high to low', value: 'patagonia_products_price_desc' },
          ],
        })
      ]);
    }
  }

  instant.search.addWidgets([
    {
      init: function () {
        document.addEventListener('DOMContentLoaded', function (event) {
          $(document).ready(function (event) {
            $(document).on("click", ".quick-add-mobile", function (event) {
              $(event.target).closest('.product-card__content').find('.myModal').css('display', 'block');
              $("body").css("overflow", "hidden");
            });

            $(document).on("click", ".myModal .close", function (event) {
              $('.myModal').css('display', 'none');
              $("body").css("overflow", "auto");
            });

            $(document).on("click", ".product-card__sizes-item", function (event) {
              setTimeout(function () {
                $('.myModal').css('display', 'none');
              }, 1500);
              $("body").css("overflow", "auto");
            });
          });
        });
      }
    },
  ]);

  // // Change display
  // instant.search.addWidgets([
  //   {
  //     init: function() {
  //       document
  //         .querySelector('.ais-search-header .ais-change-display-block')
  //         .addEventListener('click', function() {
  //           document
  //             .querySelector(
  //               '.ais-change-display-block:not(.ais-change-display-selected)'
  //             )
  //             .classList.add('ais-change-display-selected');
  //           document
  //             .querySelector(
  //               '.ais-change-display-list.ais-change-display-selected'
  //             )
  //             .classList.remove('ais-change-display-selected');
  //           document
  //             .querySelector('.ais-results-as-list')
  //             .classList.replace('ais-results-as-list', 'ais-results-as-block');
  //         });
  //       document
  //         .querySelector('.ais-search-header .ais-change-display-list')
  //         .addEventListener('click', function() {
  //           document
  //             .querySelector(
  //               '.ais-change-display-list:not(.ais-change-display-selected)'
  //             )
  //             .classList.add('ais-change-display-selected');
  //           document
  //             .querySelector(
  //               '.ais-change-display-block.ais-change-display-selected'
  //             )
  //             .classList.remove('ais-change-display-selected');
  //           document
  //             .querySelector('.ais-results-as-block')
  //             .classList.replace('ais-results-as-block', 'ais-results-as-list');
  //         });
  //     },
  //   },
  // ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function (facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function () { },
    },
  ]);

  // Create the render function
  var createDataAttributes = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function (item) {
    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function (refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          facet.title +
          '      </div>: ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function (renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function (element) {
        element.addEventListener('click', function (event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function (
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
            {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function (helper, facetsList) {
    return facetsList.some(function (f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function (
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function (resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function (facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function (facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function (facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  if (window.innerWidth < 1024) {
    var clearRefinementsWithPanelMobile = panel({
      hidden: function (options) {
        return !hasRefinements(options.helper, instant.facets.list);
      },
    })(clearRefinements);

    instant.search.addWidgets([
      clearRefinementsWithPanelMobile({
        container: document.querySelector('.ais-clear-refinements-container-mobile'),
        templates: {
          resetLabel: algolia.translations.clearAll,
        },
      })
    ]);
  }

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);

        let count = '';

        const helper = options.state;

        if (!helper) {
          return '';
        }

        if (helper.isDisjunctiveFacetRefined(widget.params.attribute)) {
          count = helper.getDisjunctiveRefinements(widget.params.attribute).length;
        } else {
          count = helper.getConjunctiveRefinements(widget.params.attribute).length;
        }

        if (count) {
          document.querySelector(`.ais-facet-count[for="${widget.params.attribute}"]`).innerText = count;
        } else {
          document.querySelector(`.ais-facet-count[for="${widget.params.attribute}"]`).innerText = '';
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  // Hits
  instant.search.addWidgets([
    infiniteHits({
      container: '.ais-hits-container',
      templates: {
        item(hit, { html, components }) {

          const getConversionData = (e, hit) => {
            const saleDiscount = hit.compare_at_price - hit.price;
            console.log("algolia.config.analytics_enabled", algolia.config.analytics_enabled)
            if (!algolia.config.analytics_enabled) return;
            var clickData ={}
            if(algolia.is_collection_results_page){
             
              clickData = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.index,
                eventName: 'Added to cart (PLP)',
                objectIDs: [hit.objectID],
                objectData: [
                  {
                    queryID: hit.queryID, // optional 
                    price:  hit.price, // required (the sale price is the per item list price minus discount) 
                    discount: saleDiscount > 0 ? saleDiscount : 0,
                    quantity: 1
                  }
                ],
                value: hit.price,
                currency: algolia.config.store_currency // required
              }; 
            }else{
             
              clickData = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.index,
                eventName: 'Added to cart (Search)',
                objectIDs: [hit.objectID],
                objectData: [
                  {
                    queryID: hit.queryID, // optional 
                    price:  hit.price, // required (the sale price is the per item list price minus discount) 
                    discount: saleDiscount > 0 ? saleDiscount : 0,
                    quantity: 1
                  }
                ],
                value: hit.price,
                currency:  algolia.config.store_currency // required
              }; 
            }

            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
             algolia.saveForConversionTracking(clickData);
          }

          const page = Math.ceil(hit.__position / algolia.config.collections_full_results_hits_per_page );
          return algolia.instantSearchProductTemplate(hit, html, components,getConversionData, page, 'product');
        },
        empty(results, { html }) {
          const productTab = document.querySelector('.ais-Header-Tab .ais-Header-Tab-item[data-for="product"]');
          const articleTab = document.querySelector('.ais-Header-Tab .ais-Header-Tab-item[data-for="article"]');
          // document.querySelector('.ais-Header').style.display = 'none';
          productTab.style.display = 'none';
          productTab.classList.remove('active');
          $(`[data-tab="product"]`).addClass('tab-hidden');
          if(articleTab.style.display !== 'none') {
            const tab = "article";
            articleTab.classList.add('active');
            $('[data-tab]').addClass('tab-hidden');
            $(`[data-tab="${tab}"]`).removeClass('tab-hidden');
          }else {
            document.querySelector('.ais-page').parentElement.classList.add('algolia-empty-results');
          }
          return `` //algolia.instantSearchNoResultTemplate(html);
        },
        showMoreText(data, { html }) {
          return html`<span>Load More</span>`;
        }
      },
      cssClasses: {
        root: 'ais-Hits',
        list: [
          'ais-Hits-list'
        ],
        item: 'ais-Hits-item'
      },
      transformItems: function (items) {
        return items.map((item, index) => ({
          ...item,
          _distinct: instant.distinct,
          can_order:
            item.inventory_management !== 'shopify' ||
            item.inventory_policy === 'continue' ||
            item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: instant.search.mainIndex.getIndexName(),
          item_index: index
        }));
      },
      cache: sessionStorageCache
    })
  ]);





  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function (e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = `${window.Shopify.routes.root}collections/${collectionHandle}`;
          }

          // Add the product handle to the link
          link = link + `${window.Shopify.routes.root}products/${productHandle}`;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }

          if (algolia.config.analytics_enabled) {

            var clickData = {}
            var clickData_pdp ={}
            const saleDiscount = parseInt(hit.dataset.comparePrice) - parseInt(hit.dataset.price);

            if(algolia.is_collection_results_page){
               clickData = {
                eventType: "view",
                index: hit.dataset.algoliaIndex,
                eventName: 'View Collection',
                queryID: hit.dataset.algoliaQueryid,
                objectIDs: [hit.dataset.algoliaObjectid],
              };
             
              clickData_pdp = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.dataset.algoliaIndex,
                eventName: 'Added to cart (PDP - collection)',
                objectIDs: [hit.dataset.algoliaObjectid],
                objectData: [
                  {
                    // revenue data for 'black-t-shirt-xxl'
                    queryID: hit.dataset.algoliaQueryid, // optional 
                    price: parseInt(hit.dataset.price), // required (the sale price is the per item list price minus discount) 
                    quantity: 1,
                    discount: saleDiscount > 0 ? saleDiscount : 0
                  }
                ],
                value: parseInt(hit.dataset.price),
                currency: "AUD" // required
              }; 
            }else{
               clickData = {
                eventType: "view",
                index: hit.dataset.algoliaIndex,
                eventName: 'View Search',
                queryID: hit.dataset.algoliaQueryid,
                objectIDs: [hit.dataset.algoliaObjectid],
              };
              clickData_pdp = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.dataset.algoliaIndex,
                eventName: 'Added to cart (PDP - search)',
                objectIDs: [hit.dataset.algoliaObjectid],
                objectData: [
                  {
                    // revenue data for 'black-t-shirt-xxl'
                    queryID: hit.dataset.algoliaQueryid, // optional 
                    price:  hit.dataset.price, // required (the sale price is the per item list price minus discount) 
                    quantity: 1,
                    discount: saleDiscount > 0 ? saleDiscount : 0
                  }
                ],
                value: hit.dataset.price,
                currency: algolia.config.store_currency // required
              }; 
              

            }

            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
             algolia.saveForConversionTracking(clickData);
             const localStorageKey_pdp = 'localStorageKey_pdp';
             localStorage.setItem(localStorageKey_pdp, JSON.stringify(clickData_pdp))
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function (e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function (opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function (e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function (facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function (e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  instant.search_article.addWidgets([
    configure({
      hitsPerPage: 16
    }),
    hits({
      container: '.ais-page-article-items',
      templates: {
        item(hit, { html, components }) {
          return algolia.instantSearchArticleTemplate(hit, html, components);
        },
        empty(results, { html }) {
          const productTab = document.querySelector('.ais-Header-Tab .ais-Header-Tab-item[data-for="product"]');
          const articleTab = document.querySelector('.ais-Header-Tab .ais-Header-Tab-item[data-for="article"]');
          // document.querySelector('.ais-Header').style.display = 'none';
          articleTab.style.display = 'none';
          articleTab.classList.remove('active');
          $(`[data-tab="article"]`).addClass('tab-hidden');

          if(productTab.style.display !== 'none') {
            const tab = "product";
            productTab.classList.add('active');
            $('[data-tab]').addClass('tab-hidden');
            $(`[data-tab="${tab}"]`).removeClass('tab-hidden');
          }else {
            document.querySelector('.ais-page').parentElement.classList.add('algolia-empty-results');
          }
          return ``;
        },
        showMoreText(data, { html }) {
          return html`<span>Load More</span>`;
        }
      },
      transformItems: function (items) {
        return items.map(item => ({
          ...item,
          _distinct: instant.distinct,
          can_order:
            item.inventory_management !== 'shopify' ||
            item.inventory_policy === 'continue' ||
            item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: instant.search.mainIndex.getIndexName()
        }));
      },
      cache: sessionStorageCache
    }),
    {
      init: function (opts) { },
      render: function (opts) {
        if (opts.results && opts.results.nbHits) {
          document.querySelector('.ais-Header-Tab-item[data-for="article"] .ais-item-count').innerText = `(${opts.results.nbHits})`;
          document.querySelector('.ais-page-article-count').innerText = `(${opts.results.nbHits})`;
        }
      },
    },
  ]);

  instant.search_product_empty.addWidgets([
    configure({
      hitsPerPage: 4
    }),
    hits({
      container: '.ais-PanelSection--trending-products-wrapper',
      templates: {
        item(hit, { html, components }) {
          const getConversionData = (e, hit) => {
            const saleDiscount = hit.compare_at_price - hit.price;
            if (!algolia.config.analytics_enabled) return;
            var clickData ={}
            if(algolia.is_collection_results_page){
             
              clickData = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.index,
                eventName: 'Added to cart (PLP)',
                objectIDs: [hit.objectID],
                objectData: [
                  {
                    queryID: hit.queryID, // optional 
                    price:  hit.price, // required (the sale price is the per item list price minus discount) 
                    discount: saleDiscount > 0 ? saleDiscount : 0,
                    quantity: 1
                  }
                ],
                value: hit.price,
                currency: algolia.config.store_currency // required
              }; 
            }else{
             
              clickData = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.index,
                eventName: 'Added to cart (Search)',
                objectIDs: [hit.objectID],
                objectData: [
                  {
                    queryID: hit.queryID, // optional 
                    price:  hit.price, // required (the sale price is the per item list price minus discount) 
                    discount: saleDiscount > 0 ? saleDiscount : 0,
                    quantity: 1
                  }
                ],
                value: hit.price,
                currency: algolia.config.store_currency // required
              }; 
            }

            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
             algolia.saveForConversionTracking(clickData);
          }

          const page = Math.ceil(hit.__position / algolia.config.collections_full_results_hits_per_page );
          return algolia.instantSearchProductTemplate(hit, html, components,getConversionData,page, "empty" );
        },
        empty(results, { html }) {
          return ``;
        }
      },
      cache: sessionStorageCache
    }),
    index({ indexName: 'patagonia_products_query_suggestions' })
    .addWidgets([
      configure({
        hitsPerPage: 8
      }),
      hits({
        container: '.ais-List--trending-items',
        templates: {
          item(hit, { html, components }) {
            return html `<a
            class="ais-ItemLink ais-ItemWrapper"
            href="${
            window.Shopify.routes.root
          }search?q=${
            encodeURIComponent(hit.query)
          }"
          >
            <div class="ais-ItemContent">
              <div class="ais-ItemContentBody">
                <div class="ais-ItemContentTitle">
                  ${
                    components.Highlight({hit: hit, attribute: 'query'})
                  }
                </div>
              </div>
            </div>
          </a>`
          },
          empty(results, { html }) {
            return ``;
          }
        },
        cache: sessionStorageCache
      }),
    ]),
    index({ indexName: 'patagonia_collections' })
    .addWidgets([
      configure({
        hitsPerPage: 4
      }),
      hits({
        container: '.ais-PanelSection--trending-collections-wrapper',
        templates: {
          item(hit, { html, components }) {
            const itemLink = `${window.Shopify.routes.root}collections/${hit.handle}`;

            return html `<a
            href="${itemLink}"
            class="ais-ItemLink"
          >
            <div class="ais-ItemWrapper">
            <div class="ais-ItemContent">
              <div class="ais-ItemContentBody">
                <div class="ais-ItemContentTitle">
                  ${components.Highlight({ hit: hit, attribute: 'title' })}
                </div>
              </div>
            </div>
            </div>
          </a>`
          },
          empty(results, { html }) {
            return ``;
          }
        },
        cache: sessionStorageCache
      }),
    ]),
  ]);

  // Pagination
  // instant.search.addWidgets([
  //   pagination({
  //     container: '.ais-pagination-container',
  //     padding: 2,
  //     maxPages: 20,
  //   }),
  // ]);

  instant.search.start();
  instant.search_article.start();
  instant.search_product_empty.start();

  instant.search.on('render', (a) => {
    let positionSettings = 4;
    let productPromotional = `
      <li class="ais-InfiniteHits-item ais-Hits-item ais-InfiniteHits-item-promotional">
        <div class="ais-promotional-wrapper"  style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.33) 0%, rgba(0, 0, 0, 0.80) 100%), url(//www.patagonia.com.au/cdn/shop/files/ae2e66cf1d70ff58bdf062ab261372ba_1000x.png?v=1787114038), lightgray 50%;" >
            
                <img class="ais-promotional-icon" src="//www.patagonia.com.au/cdn/shop/files/78f2e906a445609947dfae0e22ccb83a_72x55.png?v=1787114038" /> 
            
            
                <span class="ais-promotional-title">Ironclad Guarantee</span>
            
            
                <span class="ais-promotional-description">We guarantee everything we make.If you are not satisfied with one of our products, return it for a repair, replacement or refund.</span>
            
        </div>
      </li>
    `;

    document.querySelectorAll('.ais-InfiniteHits-item-promotional').forEach(x => x.remove());

    document.querySelectorAll('.ais-hits-container .ais-InfiniteHits-item').forEach((container, index) => {  
      if(index + 1 == positionSettings && !document.querySelector('.ais-InfiniteHits-item-promotional')) {
        container.insertAdjacentHTML("beforebegin", productPromotional);
      }
    })
  })

  instant.search_article.on('render', () => {
    if (window.innerWidth < 1024) {
      new Swiper('.ais-page-article .aa-PanelSections--footer-wrapper', {
        wrapperClass: 'aa-PanelSections--footer-body',
        slideClass: 'aa-PanelSections--faq-block',
        slidesPerView: 1.2,
        spaceBetween: 16
      });
    }

    if (document.querySelector('.ais-page-article-items').children.length > 0) {
      new Swiper('.ais-page-article-items .ais-Hits', {
        wrapperClass: 'ais-Hits-list',
        slideClass: 'ais-Hits-item',
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints: {
          1024: {
            slidesPerView: 4.2,
            spaceBetween: 16,
            navigation: {
              nextEl: '.ais-page-article--wrapper .slider__arrow--next',
              prevEl: '.ais-page-article--wrapper .slider__arrow--prev',
            }
          }
        }
      });
    }
  });

  instant.search_product_empty.on('render', () => {
    if (window.innerWidth < 1024) {
      new Swiper('.ais-PanelSection--trending-products .ais-Hits', {
          wrapperClass: 'ais-Hits-list',
          slideClass: 'ais-Hits-item',
          slidesPerView: 2,
          navigation: {
              nextEl: '.ais-PanelSection--trending-products .slider__arrow--next',
              prevEl: '.ais-PanelSection--trending-products .slider__arrow--prev',
          }
      });
    }
  });

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
